import React from 'react';
import { Card, Avatar, Space, Button, DatePicker, Row, Col, Typography } from 'antd';
import { EnvironmentOutlined, UserOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { User, EmploymentType } from '../../../../types/user.types';
import { all_routes } from '../../../../router/all_routes';
import dayjs from 'dayjs';
import { getFileUrl } from '../../../../utils/file.utils';

const { Title, Text } = Typography;

interface EmployeeHeaderProps {
  employee: User;
  selectedDate: string;
  onDateChange: (date: string) => void;
  onShowRoute: () => void;
  onHideMap: () => void;
  showMap: boolean;
  routeLoading: boolean;
}

const EmployeeHeader: React.FC<EmployeeHeaderProps> = ({
  employee,
  selectedDate,
  onDateChange,
  onShowRoute,
  onHideMap,
  showMap,
  routeLoading
}) => {
  // Saha ve hibrit çalışanlar sahaya çıkabilir (hibritlerin konumu saha modundayken kaydedilir)
  const canWorkInField =
    employee.employeeType === EmploymentType.FIELD || employee.employeeType === EmploymentType.HYBRID;
  const routes = all_routes;

  // Cinsiyete göre varsayılan avatar
  const getDefaultAvatar = () => {
    if (employee.profilePicture && employee.profilePicture.trim() !== '') {
      return getFileUrl(employee.profilePicture);
    }
    if (employee.gender === 'male') return '/assets/img/man.png';
    if (employee.gender === 'female') return '/assets/img/woman.png';
    return undefined;
  };

  const defaultAvatar = getDefaultAvatar();

  return (
    <Card style={{ marginBottom: '24px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} md={canWorkInField ? 12 : 18}>
          <Space size="large">
            <Avatar
              size={64}
              src={defaultAvatar}
              icon={!defaultAvatar ? <UserOutlined /> : undefined}
              style={{
                backgroundColor: defaultAvatar ? '#f0f0f0' : 'white',
                color: '#667eea',
                fontSize: '24px'
              }}
            >
              {!defaultAvatar && `${employee.firstName[0]}${employee.lastName[0]}`}
            </Avatar>
            <div>
              <Link 
                to={routes.employeedetails.replace(':id', employee.id.toString())}
                style={{ textDecoration: 'none' }}
              >
                <Title level={4} style={{ color: 'white', margin: 0, cursor: 'pointer' }}>
                  {employee.firstName} {employee.lastName}
                </Title>
              </Link>
              <Text style={{ color: 'white', opacity: 0.9 }}>
                {employee.email}
              </Text>
            </div>
          </Space>
        </Col>
        
        {canWorkInField && (
          <>
            <Col xs={24} md={6}>
              <DatePicker
                size="large"
                style={{ width: '100%' }}
                format="DD.MM.YYYY"
                placeholder="Tarih seçin"
                value={dayjs(selectedDate)}
                onChange={(date) => {
                  if (date) {
                    onDateChange(date.format('YYYY-MM-DD'));
                  }
                }}
              />
            </Col>
            <Col xs={24} md={6}>
              <Space style={{ width: '100%' }}>
                <Button
                  type="primary"
                  size="large"
                  icon={<EnvironmentOutlined />}
                  onClick={onShowRoute}
                  loading={routeLoading}
                  style={{ backgroundColor: 'white', color: '#667eea', borderColor: 'white' }}
                >
                  Rotayı Göster
                </Button>
                {showMap && (
                  <Button
                    size="large"
                    onClick={onHideMap}
                    style={{ backgroundColor: 'rgba(255,255,255,0.2)', color: 'white', borderColor: 'white' }}
                  >
                    Gizle
                  </Button>
                )}
              </Space>
            </Col>
          </>
        )}
      </Row>
    </Card>
  );
};

export default EmployeeHeader;

